/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, value: NonNullable<unknown> }} Ui_Laps_Row_PrimaryInputs */

const en_ui_laps_row_primary = /** @type {(inputs: Ui_Laps_Row_PrimaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} · avg ${i?.value}`)
};

const de_ui_laps_row_primary = /** @type {(inputs: Ui_Laps_Row_PrimaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} · Ø ${i?.value}`)
};

/**
* | output |
* | --- |
* | "{count} · avg {value}" |
*
* @param {Ui_Laps_Row_PrimaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_primary = /** @type {((inputs: Ui_Laps_Row_PrimaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_PrimaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_primary(inputs)
	return de_ui_laps_row_primary(inputs)
});